import { createStyles } from 'antd-style';
export var useStyles = createStyles(function (_ref) {
  var token = _ref.token;
  return {
    container: {
      '& > .ant-page-header': {
        paddingBlockEnd: 0,
        paddingBlockStart: 16,
        paddingInlineStart: 24,
        '& > .ant-page-header-breadcrumb': {
          paddingBlockStart: 0,
          '& .ant-breadcrumb-separator:nth-child(2)': {
            display: 'none'
          }
        },
        '& > .ant-page-header-heading': {
          '& > .ant-page-header-heading-extra': {
            display: 'flex'
          }
        },
        '& > .ant-page-header-footer': {
          paddingBlockStart: 16,
          '& .ant-tabs-nav::before': {
            marginInline: -40
          },
          '& .ant-tabs-tab': {
            marginRight: '6px !important',
            background: 'unset !important'
          },
          '& .ant-tabs-tab.ant-tabs-tab-active': {
            borderTop: "2px solid ".concat(token.colorPrimaryBorder)
          },
          '& .ant-tabs-tab + .ant-tabs-tab': {
            margin: '0 6px !important'
          },
          '& .ant-tabs-nav': {
            marginBottom: 0
          }
        }
      }
    },
    learner: {
      color: token.colorPrimary,
      cursor: 'pointer'
    }
  };
});